export default {
  // async
  SET_RATE: 'SET_RATE',
  GET_TRIAL: 'GET_TRIAL',
};
